import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Flex, Grid, Popover, PopoverTrigger, Spacer, Text, VStack } from '@chakra-ui/react';
import { navComponents } from './nav-icons';
import { styles } from './primary-global-navigation.styles';
import theme from '../../theme';
import { BiomeIcon, IconName } from "@codametrix/verdigris";
export const SubNav = ({ tabColor, selectionOpened, setSelectionOpened, childComponent, actionGroupOptionLabel })=>{
    const classes = styles(tabColor);
    const SelectionComponent = childComponent;
    return /*#__PURE__*/ _jsxs(Popover, {
        closeOnBlur: true,
        placement: "right",
        isOpen: selectionOpened,
        onClose: ()=>{
            setSelectionOpened(false);
        },
        trigger: "hover",
        children: [
            /*#__PURE__*/ _jsx(PopoverTrigger, {
                children: /*#__PURE__*/ _jsx(Flex, {
                    sx: classes['.insightsBox'],
                    className: `hoverCursor ${selectionOpened ? 'navItem' : ''}`,
                    onMouseEnter: ()=>setSelectionOpened(!selectionOpened),
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        direction: "row",
                        sx: classes['.insightsBox'],
                        children: [
                            /*#__PURE__*/ _jsxs(VStack, {
                                spacing: theme.space[2],
                                sx: classes['.navItemVStack'],
                                children: [
                                    /*#__PURE__*/ _jsx(Grid, {
                                        sx: classes['.iconWrapper'],
                                        onClick: ()=>setSelectionOpened(!selectionOpened),
                                        children: navComponents.Insights
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        className: "action-group-spacing",
                                        align: 'center',
                                        children: actionGroupOptionLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {}),
                            /*#__PURE__*/ _jsx(Grid, {
                                sx: classes['.insightsCarat'],
                                children: /*#__PURE__*/ _jsx(BiomeIcon, {
                                    iconName: IconName.Chevron_Right,
                                    iconSize: "12",
                                    titleText: "More"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(SelectionComponent, {
                dashboardSelectionOpened: selectionOpened
            })
        ]
    });
};
